export default {
  mobileLanding: {
    media: {
      appPreview: "Animated app preview",
      leagues: "League selection screen",
      trendFlow: "Animated trend flow",
      trendAnalysis: "Detailed trend analysis screen",
      myPicks: "My picks screen",
      checkout: "Checkout screen",
    },
    sections: {
      research: {
        heading: "Go from research to bet in seconds",
        body: "Linemate does the research for you, analyzing trends and matchups so you can go from insight to bet without hours of digging.",
      },
      leagues: {
        body: "Choose from 18+ major leagues to explore trends and plays tailored to the games and players you care about most.",
      },
      trends: {
        body: "Browse top-performing trends and choose a play backed by real data, recent performance, and relevant context.",
      },
      analysis: {
        body: "Dive deeper into each play with clear breakdowns of performance, situational context, and the key signals driving the trend.",
      },
      odds: {
        body: "Find the best available odds across operators and get the most value out of every bet.",
      },
      checkout: {
        body: "Check out in seconds with your betslip automatically filled on your preferred operator.",
      },
    },
    cta: {
      titleLineOne: "Your Home",
      titleLineTwo: "for Every Bet",
    },
  },
};